// import React from "react";
// import { Row, Col, Tab, Nav } from "react-bootstrap";
// import "./Beginner_Curriculum.css";

// const Beginner_Curriculum = () => {
//   return (
//     <Tab.Container defaultActiveKey="module0">
//       <Row className="curriculum_box">
//         {/* LEFT MODULE LIST */}
//         <Col lg={4} md={5}>
//           <Nav className="flex-column module_nav">
//             <Nav.Link eventKey="module0">
//               <h6>
//                 Module 0 -{" "}
//                 <span className="green">Beginner Starting Point</span>
//               </h6>
//               <p>Programming Constructs</p>
//             </Nav.Link>

//             <Nav.Link eventKey="module1">
//               <h6>
//                 Module 1 -{" "}
//                 <span className="green"> Advance Starting Point </span>
//               </h6>
//               <p>Master problem solving in DS & Algo</p>
//             </Nav.Link>

//             <Nav.Link eventKey="module2">
//               <h6>Module 2</h6>
//               <p>SQL</p>
//             </Nav.Link>

//             <Nav.Link eventKey="module3">
//               <h6>Module 3</h6>
//               <p>System Design - LLD + HLD</p>
//             </Nav.Link>

//             <Nav.Link eventKey="module4">
//               <h6>Module 4</h6>
//               <p>System Design - LLD + HLD</p>
//             </Nav.Link>

//             <Nav.Link eventKey="module5">
//               <h6>Module 5</h6>
//               <p>ML & GenAI for SDEs</p>
//             </Nav.Link>

//             <Nav.Link eventKey="module6">
//               <h6>Module 6</h6>
//               <p>Important addons</p>
//             </Nav.Link>
//           </Nav>
//         </Col>

//         {/* RIGHT CONTENT */}
//         <Col lg={8} md={7}>
//           <Tab.Content className="module_content">
//             <Tab.Pane eventKey="module0">
//               <div className="module_header">
//                 <h5>📦 Module 0 - Programming Constructs</h5>
//                 <span className="duration">4 Weeks</span>
//               </div>

//               <p className="module_text">
//                 For Beginners, it is first important to build command over
//                 programming constructs.
//               </p>

//               <p className="module_text">
//                 Within this module, our goal is to help you be confident with
//                 coding fundamentals.
//               </p>

//               <h6 className="topic_head">Topics covered:</h6>

//               <ul className="topic_list">
//                 <li>Introduction to Programming</li>
//                 <li>Input Output and Data Types</li>
//                 <li>Operators</li>
//                 <li>Conditional Statements</li>
//                 <li>Loops</li>
//                 <li>Pattern Problems</li>
//                 <li>Functions</li>
//                 <li>1D Array</li>
//                 <li>Number System & Maths</li>
//                 <li>String Implementation</li>
//                 <li> Introduction to Data Structures</li>
//                 <li>Time & Space Complexity</li>
//               </ul>
//             </Tab.Pane>

//             <Tab.Pane eventKey="module1">
//               <div className="module_header">
//                 <h5>Module 1 - Data Structures & Algorithms</h5>
//               </div>
//             </Tab.Pane>

//             <Tab.Pane eventKey="module2">
//               <div className="module_header">
//                 <h5>Module 2 - SQL</h5>
//               </div>
//             </Tab.Pane>

//             <Tab.Pane eventKey="module3">
//               <div className="module_header">
//                 <h5>Module 3 - System Design</h5>
//               </div>
//             </Tab.Pane>

//             <Tab.Pane eventKey="module4">
//               <div className="module_header">
//                 <h5>Module 4 - Advanced System Design</h5>
//               </div>
//             </Tab.Pane>

//             <Tab.Pane eventKey="module5">
//               <div className="module_header">
//                 <h5>Module 5 - ML & GenAI for SDEs</h5>
//               </div>
//             </Tab.Pane>

//             <Tab.Pane eventKey="module6">
//               <div className="module_header">
//                 <h5>Module 6 - Important addons</h5>
//               </div>
//             </Tab.Pane>
//           </Tab.Content>
//         </Col>
//       </Row>
//     </Tab.Container>
//   );
// };

// export default Beginner_Curriculum;


import React from "react";
import { Row, Col, Tab, Nav } from "react-bootstrap";
import "./Beginner_Curriculum.css";

const Beginner_Curriculum = ({ modules }) => {
  if (!modules || modules.length === 0) return <p>No beginner modules available.</p>;

  return (
    <Tab.Container defaultActiveKey={modules[0].id.toString()}>
      <Row className="curriculum_box">
        {/* LEFT MODULE LIST */}
        <Col lg={4} md={5}>
          <Nav className="flex-column module_nav">
            {modules.map((module, index) => (
              <Nav.Link eventKey={module.id.toString()} key={module.id}>
                <h6>
                  {module.title} -{" "}
                  <span className="green">{module.subtitle}</span>
                </h6>
                {/* <p>{module.shortDescription || module.subtitle}</p> */}
              </Nav.Link>
            ))}
          </Nav>
        </Col>

        {/* RIGHT CONTENT */}
        <Col lg={8} md={7}>
          <Tab.Content className="module_content">
            {modules.map((module) => (
              <Tab.Pane eventKey={module.id.toString()} key={module.id}>
                <div className="module_header">
                  <h5>{module.title}</h5>
                  {module.duration && <span className="duration">{module.duration}</span>}
                </div>

                {module.description ? (
                  <div
                    className="module_text"
                    dangerouslySetInnerHTML={{ __html: module.description }}
                  />
                ) : (
                  <p className="module_text">No description available.</p>
                )}

                {module.topics && module.topics.length > 0 && (
                  <>
                    <h6 className="topic_head">Topics covered:</h6>
                    <ul className="topic_list">
                      {module.topics.map((topic, i) => (
                        <li key={i}>{topic}</li>
                      ))}
                    </ul>
                  </>
                )}
              </Tab.Pane>
            ))}
          </Tab.Content>
        </Col>
      </Row>
    </Tab.Container>
  );
};

export default Beginner_Curriculum;